import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Offcanvas from "react-bootstrap/Offcanvas";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { useGetAllCategoryListQuery } from "../../../../utils/api/category/category.api";
import { QueryUrl, sortByAlphabetical } from "../../../../utils/Utils";
import { AlertInfo } from "../../../common/Alert";

const PRIX_PALIERS = [
  0, 50_000, 100_000, 250_000, 500_000, 1_000_000, 2_000_000, 3_500_000, 5_000_000,
];
const PRIX_SLIDER_MAX = PRIX_PALIERS[PRIX_PALIERS.length - 1];

function priceToMinIndex(price: number): number {
  const i = PRIX_PALIERS.findIndex((p) => p >= price);
  return i === -1 ? PRIX_PALIERS.length - 1 : i;
}
function priceToMaxIndex(price: number): number {
  for (let i = PRIX_PALIERS.length - 1; i >= 0; i--) {
    if (PRIX_PALIERS[i] <= price) return i;
  }
  return 0;
}
function clampToPalier(price: number, forMin: boolean): number {
  if (forMin) return PRIX_PALIERS[priceToMinIndex(price)];
  return PRIX_PALIERS[priceToMaxIndex(price)];
}

let options = [
  {
    label: "Nombre d'avis",
    value: "avreageRate",
  },
  {
    label: "Date de création",
    value: "createdAt",
  },
  {
    label: "Nom",
    value: "name",
  },
  {
    label: "Note moyenne",
    value: "rateCount",
  },
  {
    label: "Prix",
    value: "price",
  },
];
function FilterMobileItem({
  searchParams,
  setSearchParams,
  query,
  setQuery,
  setPage,
  show,
  setShow,
}) {
  const [selectedCat, setSelectedCat] = React.useState<any>(
    searchParams?.get("sous_categorie")
      ? JSON.parse(searchParams?.get("sous_categorie") || "[]")
      : []
  );
  const [parent, setParent] = React.useState<any>(
    searchParams?.get("categorie") || ""
  );
  const [value, setValue] = React.useState<{ min: number; max: number }>(() => {
    const pmin = searchParams?.get("prix_min");
    const pmax = searchParams?.get("prix_max");
    const minPrice = pmin ? Number(pmin) : 0;
    const maxPrice = pmax ? Number(pmax) : PRIX_SLIDER_MAX;
    return {
      min: clampToPalier(minPrice, true),
      max: clampToPalier(maxPrice, false),
    };
  });
  React.useEffect(() => {
    const pmin = searchParams?.get("prix_min");
    const pmax = searchParams?.get("prix_max");
    const minPrice = pmin ? Number(pmin) : 0;
    const maxPrice = pmax ? Number(pmax) : PRIX_SLIDER_MAX;
    setValue({
      min: clampToPalier(minPrice, true),
      max: clampToPalier(maxPrice, false),
    });
  }, [searchParams?.get("prix_min"), searchParams?.get("prix_max")]);
  const {
    data = { results: [] },
    isLoading,
    refetch,
  } = useGetAllCategoryListQuery();

  //  Protection contre l'écrasement des query params au montage
  const isBlockedRef = useRef(true);
  const initialParamsRef = useRef({
    categorie: searchParams?.get("categorie") || "",
    sous_categorie: searchParams?.get("sous_categorie") || "",
    prix_min: searchParams?.get("prix_min") || "",
    prix_max: searchParams?.get("prix_max") || "",
  });

  React.useEffect(() => {
    // Débloquer après 500ms pour permettre l'initialisation
    const timer = setTimeout(() => {
      isBlockedRef.current = false;
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);

  React.useEffect(() => {
    //  Ne pas modifier les searchParams pendant le délai de blocage
    if (isBlockedRef.current) return;
    
    let params = QueryUrl("", query);
    setSearchParams(params);
  }, [query]);

  React.useEffect(() => {
    let queryCopy = { ...query };
    queryCopy = {
      ...queryCopy,
      sous_categorie: selectedCat?.length ? JSON.stringify(selectedCat) : "",
    };
    // console.log("query selectedCat", queryCopy);

    setQuery(queryCopy);
  }, [selectedCat]);

  const handleFilter = () => {
    const isFullRange = value.min === 0 && value.max === PRIX_SLIDER_MAX;
    let queryCopy = { ...query };
    queryCopy = {
      ...queryCopy,
      prix_min: isFullRange ? "" : String(value.min),
      prix_max: isFullRange ? "" : String(value.max),
    };

    setPage(1);
    setQuery(queryCopy);
  };

  useEffect(() => {
    handleFilter();
  }, [value]);

  const handleSelectedCat = (e: ChangeEvent<HTMLInputElement>) => {
    let selectedCopy = [...selectedCat];

    if (e?.target?.checked) {
      selectedCopy?.push(e?.target?.value);
    } else {
      selectedCopy = selectedCopy?.filter((el) => el !== e?.target?.value);
    }
    setSelectedCat(selectedCopy);

    setPage(1);
  };

  const handleClick = (item) => {
    setParent(item?.slug);
    let queryCopy = { ...query };
    queryCopy = {
      ...queryCopy,
      categorie: item?.slug,
      sous_categorie: [],
    };
    // console.log("query selectedCat", queryCopy);
    setSelectedCat([]);
    setQuery(queryCopy);
    setPage(1);
  };

  const handleClose = () => {
    setShow(false)
  }

  return (
    <Offcanvas show={show} onHide={handleClose} className="offcanvas-filter-mobile">
      <Offcanvas.Header closeButton className="b-b-1">
        <Offcanvas.Title>Filtrer</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          {/* <div className="content-btn-title-home-page py-3">
                    <div className="tab-dash-admin-filter-container">
                      <form className="tab-dash-admin-filter-form">
                        <div className="">
                          <label
                            htmlFor="filtreProduit"
                            className="tab-dash-admin-filter-label"
                            style={{ fontWeight: 700, color: "#000" }}
                          >
                            Trier par
                          </label>
                        </div>
                        <div className="">
                          <select
                            className="form-control filter-select-product"
                            value={searchParams?.get("orderBy") || ""}
                            onChange={(e) => handleSelect(e)}
                          >
                            <option value="">Pertinence</option>
                            {options?.map((opt, i) => (
                              <option value={opt?.value} key={i}>
                                {" "}
                                {opt?.label}{" "}
                              </option>
                            ))}
                          </select>
                        </div>
                      </form>
                    </div>
                  </div> */}
          <div className="row mt-3">
            {/* {!!isLoading && <ProductItemsSkeleton />} */}

            {/* {!isLoading &&
                      (data?.results?.length ? (
                        data?.results?.map((produit) => (
                          <div
                            className="col-md-6 col-lg-4 col-xl-3 mb-3 col-product-item d-flex"
                            key={produit._id}
                          >
                            <ProductItem item={produit} key={produit._id} />
                          </div>
                        ))
                      ) : (
                        <AlertInfo message="Aucune produit disponible pour le moment!" />
                      ))} */}
            {/* {!! ProductData && ProductData.map((product, key) => {
                        return(
                          <div
                            className="col-md-4 mb-3 col-product-item d-flex"  
                            key={key}
                          >
                            <ProductItem item={product} key={key} refetch={refetch} />
                          </div>
                        )
                      })
                      } */}
          </div>
          <div className="d-flex justify-content-center">
            {/* {data?.nbPage && data?.nbPage > 1 ? (
                      <Pagination
                        page={page}
                        total={data?.nbPage}
                        onPageChange={(page) => setPage(page)}
                      />
                    ) : null} */}
          </div>
        </div>
        <div className="content-others-value filter-mobile-categories">
          <p className="filter-mobile-categories-title">Catégories</p>
          {/* <div
            className="category-filter-list-check"
          >
            {data?.results?.map((item, i) => (
            <label className="material-checkbox mb-3" key={i}>
              <input defaultChecked={catgoryId==item?.id} type="checkbox"  name="categorie" value={item?.id} onChange={(e)=>handleSelectCategory(e)} />
              <span className="checkmark"></span>
                {item?.nom}
            </label>
            ))}
          </div> */}

          <div className="categories_and_subcategories">
            {!!isLoading && <p>Loading...</p>}

            <Accordion
              className="category-filter-acordion"
              id="accordionCategories"
              alwaysOpen
              defaultActiveKey={["0"]}
            >
              {!isLoading &&
                (sortByAlphabetical(data?.results)?.length ? (
                  sortByAlphabetical(data?.results)?.map((category, i) => (
                    <Accordion.Item
                      eventKey={`${i}`}
                      key={category?.id}
                      className="category-filter-acordion-item mb-1"
                    >
                      <Accordion.Header
                        className="mb-0 filter-mobile-category-header"
                        onClick={() => handleClick(category)}
                      >
                        <span className="category_parent_name filter-mobile-category-name">
                          {category?.nom}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body className="filter-mobile-subcategories-body">
                        {category?.sous_categorie?.length ? (
                          sortByAlphabetical(category?.sous_categorie)?.map(
                            (sub) => (
                              <div
                                className="content-col-form-register-tabs filter-mobile-subcategory-item"
                                key={sub?.id}
                              >
                                <label className="label-checkbox-register-tabs category_child_name filter-mobile-subcategory-label">
                                  <input
                                    type="checkbox"
                                    className="input-checkbox-register-tabs me-2"
                                    checked={
                                      selectedCat &&
                                      selectedCat?.length &&
                                      selectedCat?.includes(sub?.slug)
                                    }
                                    value={sub?.slug}
                                    onChange={(e) => handleSelectedCat(e)}
                                  />
                                  {sub?.nom}
                                </label>
                              </div>
                            )
                          )
                        ) : null}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <AlertInfo message="Aucune catégorie disponible pour le moment" />
                ))}
            </Accordion>
          </div>
        </div>
        <p className="content-title-section-left">
          Prix <span style={{ fontWeight: 300, fontSize: 14 }}>(F CFA)</span>
        </p>
        <div className="filter-prix-slider pb-4 py-4">
          <InputRange
            minValue={0}
            maxValue={PRIX_PALIERS.length - 1}
            step={1}
            value={{
              min: PRIX_PALIERS.indexOf(value.min) >= 0 ? PRIX_PALIERS.indexOf(value.min) : 0,
              max: PRIX_PALIERS.indexOf(value.max) >= 0 ? PRIX_PALIERS.indexOf(value.max) : PRIX_PALIERS.length - 1,
            }}
            onChange={(val) => {
              const v = val as { min: number; max: number };
              setValue({
                min: PRIX_PALIERS[v.min] ?? 0,
                max: PRIX_PALIERS[v.max] ?? PRIX_SLIDER_MAX,
              });
            }}
            formatLabel={(idx) => `${Number(PRIX_PALIERS[idx]).toLocaleString("fr-FR")} F`}
          />
          <div className="filter-prix-paliers mt-1">
            {PRIX_PALIERS.map((p, i) => (
              <span
                key={p}
                className={`filter-prix-palier ${i === 0 ? "palier-first" : ""} ${i === PRIX_PALIERS.length - 1 ? "palier-last" : ""}`}
                style={{ left: `${(i / (PRIX_PALIERS.length - 1)) * 100}%` }}
              >
                {p >= 1_000_000 ? `${p / 1_000_000}M` : p >= 1_000 ? `${p / 1_000}k` : p}
              </span>
            ))}
          </div>
          <p className="filter-prix-slider-range mt-2 mb-0 small text-muted">
            {value.min.toLocaleString("fr-FR")} F CFA – {value.max.toLocaleString("fr-FR")} F CFA
          </p>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default FilterMobileItem;
